import React from 'react';
import { Link } from 'react-router-dom';
import { useOrgSettings } from '../contexts/OrgSettingsContext';

export const Footer: React.FC = () => {
  const { displayName, mainSiteUrl } = useOrgSettings();

  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white py-4 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-gray-500">
        <span>&copy; {currentYear} {displayName || 'Privacy Center'}</span>
        <nav className="flex items-center gap-1 flex-wrap justify-center">
          <Link
            to="/aboutus"
            className="hover:text-primary transition-colors px-2 py-1"
          >
            About Us
          </Link>
          {mainSiteUrl && (
            <>
              <span className="text-gray-300">&middot;</span>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary transition-colors px-2 py-1"
              >
                Main Site
              </a>
            </>
          )}
        </nav>
      </div>
    </footer>
  );
};
